<section class="py-5" style="background: linear-gradient(120deg, #f3f7fa 60%, #e8f0fb 100%);">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-7 text-center">
                <h2 class="fw-bold mb-3" style="font-size:2.2rem;">
                    <span class="text-primary">Ihre Zielgruppe</span> in einer Liste.<br>
                    Sofort. Präzise. DSGVO-konform.
                </h2>
                <a
                        href="#feature-list"
                        class="btn btn-primary btn-lg px-5 shadow-lg cta-animate"
                >
                    Jetzt Liste konfigurieren <i class="fa fa-arrow-right ms-2"></i>
                </a>
                <p class="mb-4 lead text-secondary" style="font-size:1.17rem;">
                    Mit nur wenigen Klicks erhalten Sie aktuelle, individuelle Firmenlisten für Ihr Marketing oder Vertrieb – ohne Wartezeit, ohne Umwege.
                </p>
            </div>
        </div>
    </div>
</section>